import React, { useRef } from 'react';
import getConfig from 'next/config';
import ReCAPTCHA from 'react-google-recaptcha';
import Form from '../Form/Form';
import { TEST_EMAIL_REGEX } from '../../utils/auth-utils';

const { publicRuntimeConfig: { config } } = getConfig();

function AuthForm({
  children, submitCallback, getEmail, submitLabel, isDisabled = false, className = '', testId = '',
}) {
  const recaptcha = useRef(null);

  const onSubmit = async () => {
    // Need to do strict comparison since env variable is of type string
    // (on config file comparison does not return the correct value)
    if (String(config.DISABLE_RECAPTCHA) === 'true' || getEmail()?.match(TEST_EMAIL_REGEX)) {
      submitCallback();
    } else {
      recaptcha.current.reset();
      recaptcha.current.execute();
    }
  };

  return (
        <div>
            <Form 
              className={className} 
              onAction={onSubmit} 
              actionLabel={submitLabel}
              testId={testId}
              isDisabled={isDisabled}>
                {children}
            </Form>
            <ReCAPTCHA className="invisible"
                ref={recaptcha} onChange={submitCallback} size="invisible"
                sitekey="6LclM1YUAAAAAAdVfjS-X7IkZgJDEu7gJBYBorzx"
            />
        </div>
  );
}

export default AuthForm;
